import React, { createContext, useContext, useState, useEffect } from 'react';
import { Preloader } from '../Components/Preloader/Preloader';

interface AppInitContextType {
  isInitialized: boolean;
  isAuthenticated: boolean;
}

const AppInitContext = createContext<AppInitContextType>({ 
  isInitialized: false,
  isAuthenticated: false
});

export const authStateChanged = new Event('authStateChanged');

export const AppInitProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const initApp = async () => {
      try {
        await fetch('/config.json').then(response => response.json());
        const idToken = sessionStorage.getItem("idToken");
        setIsAuthenticated(!!idToken);
        setIsInitialized(true);
      } catch (error) {
        console.error('Error initializing app:', error);
        setIsInitialized(true);
      }
    };

    initApp();
  }, []);

  useEffect(() => {
    const handleAuthChange = () => {
      const idToken = sessionStorage.getItem("idToken");
      setIsAuthenticated(!!idToken);
    };

    window.addEventListener('authStateChanged', handleAuthChange);
    return () => {
      window.removeEventListener('authStateChanged', handleAuthChange);
    };
  }, []);

  if (!isInitialized) {
    return <Preloader isActive={true} />;
  }

  return (
    <AppInitContext.Provider value={{ isInitialized, isAuthenticated }}>
      {children}
    </AppInitContext.Provider>
  );
};

export const useAppInit = () => useContext(AppInitContext);